
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity-verification/link",
      function () {
        return require("private-next-pages/docs/identity-verification/link.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity-verification/link"])
      });
    }
  